export const MAX_UPDATE_POLICY_RETRIES = 3;

export interface Client {
  clientId: string;
  clientSecret: string;
}
